<template>
    <section class="px-content pt-[60px] pb-[96px] will-change" :data-scroll-section="inner == 'false'">
        <div class="flex flex-col items-center text-center mb-16" data-scroll data-scroll-class="xyz-in" xyz="fade down duration-15">
            <h2 class="text-4xl xl:text-heading mb-8" v-show="blockData.title">{{ blockData.title }}</h2>
            <div class="xl:max-w-[40vw]" v-show="blockData.text" v-html="blockData.text"></div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            <div class="relative overflow-hidden cursor-pointer after:block after:bg-black after:opacity-20 after:absolute after:w-full after:h-full after:z-[8] after:top-0 after:left-0 hover:after:opacity-50 after:transition-opacity"
            v-show="blockData.cards" v-for="( card, index ) in blockData.cards" :key="index" @click="goToLocation(card)">
                    <img class="object-cover w-full h-full custom-easing-1" v-show="card.image" :src="card.image.url" :alt="card.image.alt"
                    data-scroll
                    data-scroll-class="xyz-in"
                    xyz="fade big-25% duration-25">
                <span class="text-2xl text-white text-center font-canela px-4 w-full absolute top-1/2 -translate-y-1/2  z-10" v-show="card.title">{{ card.title }}</span>
            </div>
        </div>
    </section>
</template>


<script>
    export default {
        name: 'TwoCardsText',
        data() {
            return {}
        },
        mounted() {

        },
        methods: {
            goToLocation(card) {
                window.location.href = card.cta.url;
            }
        },
    }
</script>

<style>
  .custom-easing-1 {
    --xyz-ease: cubic-bezier(0,.83,0,1);
  }
</style>
